import React from "react";

const ConceptoProgressBar = ({
  idPartida,
  programado,
  real,
  handleClick,
  realClass = "real-gradiente",
  programadoClass = "programado-gradiente",
  height = 25,
  showLabels = false,
}) => {
  const labelStyle = {
    top: "50%",
    transform: "translateY(-50%)",
    zIndex: 2,
    fontSize: 10,
    lineHeight: 1,
  };

  // Fall back to 0 width / "-" label when a value isn't available (NaN).
  const realNum = Number.isFinite(real) ? real : 0;
  const programadoNum = Number.isFinite(programado) ? programado : 0;
  const realLabel = Number.isFinite(real) ? `${real}%` : "-";
  const programadoLabel = Number.isFinite(programado) ? `${programado}%` : "-";

  // Pick the text color from the bar segment behind a label at horizontal
  // position `x` (0-100). Z-order: the real (green) bar paints over the
  // programado fill (blue/orange/red), which paints over the empty (gray) track.
  //   blue programado fill → white;  green real / gray track → black.
  const labelColorAt = (x) => {
    if (realNum >= x) return { color: "#212529", textShadow: "0 0 2px rgba(255,255,255,0.7)" };
    if (programadoNum >= x) return { color: "#fff", textShadow: "0 0 2px rgba(0,0,0,0.5)" };
    return { color: "#212529", textShadow: "0 0 2px rgba(255,255,255,0.7)" };
  };
  const realLabelColor = labelColorAt(2);
  const programadoLabelColor = labelColorAt(98);
  return (
    <div
      className="progress mw-100 position-relative"
      role="progressbar"
      aria-label="Basic example"
      aria-valuenow="75"
      aria-valuemin="0"
      aria-valuemax="100"
      style={{ height }}
      onClick={() => handleClick(idPartida)}
    >
      <div
        className={`progress-bar ${programadoClass} position-absolute`}
        style={{ width: `${programadoNum}%`, height }}
      ></div>
      <div
        className={`progress-bar ${realClass} position-absolute`}
        style={{ width: `${realNum}%`, height }}
      ></div>
      {showLabels && (
        <>
          <span
            className="position-absolute fw-semibold"
            style={{ ...labelStyle, ...realLabelColor, left: 6 }}
          >
            {realLabel}
          </span>
          <span
            className="position-absolute fw-semibold"
            style={{ ...labelStyle, ...programadoLabelColor, right: 6 }}
          >
            {programadoLabel}
          </span>
        </>
      )}
    </div>
  );
};
export default ConceptoProgressBar;
